/**
 * Terms of Service — DRAFT (FR-P-4).
 *
 * Sprint 0 Day 2 ships placeholder copy per the Sprint Day-by-Day cut
 * point. Final copy through Clinician Assist legal before public launch.
 *
 * Scope per Spec FR-P-4:
 * - Foundations education-only positioning (D18)
 * - Refund policy
 * - Honor-code requirement
 * - Accreditor-required record retention exception to RTBF
 */
import type * as React from "react";

export function TermsOfService(): React.JSX.Element {
  return (
    <article className="prose mx-auto max-w-3xl px-4 py-12 sm:px-6 sm:py-16">
      <p className="text-xs font-semibold uppercase tracking-wider text-amber-700">
        DRAFT — placeholder copy, pending legal review
      </p>
      <h1 className="mt-2 text-3xl font-bold text-foreground">
        Terms of Service
      </h1>
      <p className="mt-2 text-sm text-muted-foreground">Last updated: 2026-05-07</p>

      <section className="mt-8 space-y-4 text-foreground">
        <h2 className="text-xl font-semibold text-foreground">
          Foundations Certificate is education only
        </h2>
        <p>
          The CaiT Foundations Certificate is an education credential. It does
          NOT authorize you to use Casey or any production CaiT-style assistant
          in clinical care. The Practitioner credential, which lands in MVP,
          is the authorization gate for production use.
        </p>

        <h2 className="text-xl font-semibold text-foreground">
          Honor code
        </h2>
        <p>
          By enrolling, you agree to complete all assessments without
          reference to outside materials, AI assistants, or other people; not
          to record, reproduce, or share exam content; and to treat your
          Foundations Certificate as an honest reflection of your own
          knowledge. You will be asked to attest to this honor code before
          beginning the final exam.
        </p>

        <h2 className="text-xl font-semibold text-foreground">
          Refunds
        </h2>
        <p>
          Phase 0 Founding Cohort enrollment is free, so refunds are not
          applicable. The standard refund policy (full refund within 14 days
          of enrollment, partial refund prorated against modules completed
          afterwards) takes effect at MVP when paid enrollment opens.
        </p>

        <h2 className="text-xl font-semibold text-foreground">
          Continuing-education credit
        </h2>
        <p>
          Phase 0 Foundations does not carry CE credit. APA, NBCC, and ASWB
          sponsorships are submitted in MVP/V1 and may be retroactively
          credited.
        </p>

        <h2 className="text-xl font-semibold text-foreground">
          Right to be forgotten
        </h2>
        <p>
          You may request deletion of your account and associated data at any
          time. If you have been issued a Foundations Certificate, the
          certificate record is preserved with anonymized name to satisfy
          accreditor record-retention requirements; the credential ID remains
          valid for third-party verification.
        </p>

        <h2 className="text-xl font-semibold text-foreground">
          Contact
        </h2>
        <p>
          Questions: hello@cait.academy
        </p>
      </section>
    </article>
  );
}
